import { createContext, useContext, useCallback } from 'react';
import { useTranslation as useTranslationI18n, Trans } from 'react-i18next';

// Context que define o namespace default da subtree. Cada app envolve
// sua árvore com `<I18nNamespaceProvider value="module-X">` uma vez —
// daí pra baixo, `useTranslation()` resolve as chaves contra esse ns
// sem que cada call-site precise declarar/repassar. Per-call override
// (`getTranslationAsString(key, { ns: 'Y' })`) continua funcionando.
const I18nNamespaceContext = createContext(null);

export const I18nNamespaceProvider = I18nNamespaceContext.Provider;

export const useTranslation = (overrideNs) => {
  const contextNs = useContext(I18nNamespaceContext);
  const ns = overrideNs || contextNs || undefined;
  const { t, i18n } = useTranslationI18n(ns);

  const getTranslation = useCallback(
    (key, interpolation = {}, components = {}, defaultValue = '') =>
      <Trans i18nKey={key} values={interpolation} components={components} defaultValue={defaultValue} />,
    []
  );

  const getTranslationAsString = (key, interpolation = {}, defaultValue = '') => t(key, { ...interpolation, defaultValue });

  const hasTranslation = (key) => t(key) !== key;

  return {
    i18n,
    getTranslation,
    hasTranslation,
    getTranslationAsString,
  }

}
